// extracted by mini-css-extract-plugin
export default {"bg":"modal_bg__aFrG8"};